<div
    *transloco="let t"
    class="bazis-item"
    [ngClass]="{
        'bazis-item--selected':
            valuesMap &&
            valuesMap.has(
                fieldForId && item.$snapshot[fieldForId]?.id
                    ? item.$snapshot[fieldForId]?.id
                    : item.id
            ),
        'bazis-checkbox': multiple && hasVisualFlag,
        'bazis-radio': mqSrv.inIntervalBreakpoint('xs', 'lg') && !multiple && hasVisualFlag,
        'bazis-item--disabled': item.$snapshot.disabled ? item.$snapshot.disabled : item.disabled,
    }"
    (click)="toggleSelectedValue($event)"
>
    <span
        [ngClass]="{
            'bazis-checkbox__label': multiple && hasVisualFlag,
            'bazis-radio__label':
                mqSrv.inIntervalBreakpoint('xs', 'lg') && !multiple && hasVisualFlag,
        }"
    >
        <ng-container
            [ngTemplateOutlet]="infiniteListTpl"
            [ngTemplateOutletContext]="{ item: item }"
        ></ng-container>
        <ng-container *ngIf="!infiniteListTpl">
            {{ item.$snapshot.name || t(item.$snapshot.nameKey, item.$snapshot.nameParams) }}
        </ng-container>
    </span>
</div>
